module.exports = __webpack_public_path__ + "img/icon-left-arrow.e8b3b79b.svg";